import { cn } from "@wags/ui/ui-utils";
import { VercelImage } from "@wags/ui/vercel-image.tsx";

function ParentTile({
    parent,
    relation,
}: {
    parent: { name: string; media: Array<{ url: string; id: string }> } | null;
    relation: string;
}) {
    if (!parent) return null;

    const photo = parent?.media[0];
    return (
        <div>
            <div
                className={cn(
                    "overflow-hidden rounded-card bg-black/5 aspect-4/3",
                    photo && "img-inset",
                )}
            >
                {photo && (
                    <VercelImage
                        src={photo.url}
                        listingMedia
                        alt={`${parent?.name} - ${relation.toLowerCase()}`}
                        width={600}
                        height={450}
                        className="h-full w-full object-cover"
                    />
                )}
            </div>
            {parent?.name && (
                <p className="mt-2 text-body-small text-doberman-black/60">
                    {parent.name} &middot; {relation}
                </p>
            )}
        </div>
    );
}

export function MeetTheParents({
    parentDogs,
    dogName,
    sexAvailability,
}: {
    parentDogs: {
        mom: { name: string; media: Array<{ url: string; id: string }> } | null;
        dad: { name: string; media: Array<{ url: string; id: string }> } | null;
    };
    dogName: string;
    sexAvailability: string;
}) {
    return (
        <div>
            <h3 className="text-section-title text-doberman-black text-balance">
                Meet the parents
            </h3>
            <div className="mt-6 grid grid-cols-2 gap-4">
                <ParentTile parent={parentDogs.mom} relation="Mother" />
                <ParentTile parent={parentDogs.dad} relation="Father" />
            </div>
            <div className="mt-6 text-body text-doberman-black/80 max-w-prose">
                <p className="text-label">
                    Want to know what {dogName} will be like as an adult?
                </p>
                <p className="mt-3">
                    Meet{" "}
                    {sexAvailability === "FEMALE"
                        ? "her"
                        : sexAvailability === "MALE"
                          ? "his"
                          : "their"}{" "}
                    parents.
                </p>
            </div>
        </div>
    );
}
